import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0013ef4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(">")
const _hoisted_3 = {
  key: 0,
  class: "panel-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron = _resolveComponent("chevron")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["panel-heading", { collapsible: _ctx.collapsible, expanded: _ctx.expanded }]),
      role: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      tabindex: "0"
    }, [
      _renderSlot(_ctx.$slots, "heading", {}, undefined, true),
      (_ctx.collapsible)
        ? (_openBlock(), _createBlock(_component_chevron, {
            key: 0,
            style: {"flex-grow":"0"},
            class: _normalizeClass({ rotate: _ctx.expanded })
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 34),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}